/**
 * Curated editorial / architectural imagery used across the Scalexa site.
 * Each URL has been verified to load and visually match the brand's
 * premium B2B consulting aesthetic (no stock-photo people, no AI diagrams).
 */

const u = (id, w = 1400, q = 80) =>
    `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=${q}`;

export const IMG = {
    // Hero — glass blueprint shot (original from design guidelines)
    hero: "https://images.unsplash.com/photo-1462556791646-c201b8241a94?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGFyY2hpdGVjdHVyYWwlMjBnbGFzcyUyMGJsdWVwcmludHxlbnwwfHx8Ymx1ZXwxNzgyMjMyNDMyfDA&ixlib=rb-4.1.0&q=85",

    // Abstract architectural (kaleidoscopic glass)
    abstract:
        "https://images.unsplash.com/photo-1483959651481-dc75b89291f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMGFyY2hpdGVjdHVyYWwlMjBnbGFzcyUyMGJsdWVwcmludHxlbnwwfHx8Ymx1ZXwxNzgyMjMyNDMyfDA&ixlib=rb-4.1.0&q=85",

    // Corporate skyscrapers shot from below
    towers: u("1486406146926-c627a92ad1ab"),

    // Modern office corridor / interior architecture
    office: u("1497366216548-37526070297c"),

    // Architect drafting a blueprint — captures the "engineered" mood
    cornerSky: u("1503387762-592deb58ef4e"),
};
